import React from "react";
import "../Styles/error.scss";
import { Link } from "react-router-dom";

function ErrorPage() {
  return (
    <div className="error-parent">
      <div className="img-parent">
        <div className="error-cont">
          <h1>404</h1>
          <h2>Oops! Page Not Found</h2>
          <Link className="btn" to="/">Back To Home</Link>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;
